<footer class="footer-section">
    <div class="container">
        <div class="footer-content justify-content-center">
            <ul class="top-bar-menu-right footer-menu mb-0 align-items-center">
                <li> <a href="https://mohawkind.com/legal.php" target="_blank"> Legal</a></li>
                <li> <a href="https://mohawkind.com/privacy-policy.php" target="_blank"> Privacy Policy </a></li>
                <li> <span class="copy-right-text">&copy; 2026 Mohawk Industries, Inc.</span></li>
            </ul>
        </div>
    </div>
</footer>